// extracted by mini-css-extract-plugin
export default {"chatPage":"Chat_chatPage__9sDB0","form-control":"Chat_form-control__vF1pt"};